import { useIntl } from 'react-intl';
import { Col, Input, Row } from 'antd';

import { ExtraFiltersProps } from '@/types/ExtraFiltersProps';

import { ListForecastPayableQuery } from '@/core/domain/financial/ForecastPayable/ForecastPayable.types';
import CompaniesInfiniteSelectField from '@/components/_common/CompaniesInfiniteSelectField';

function ForecastPayableExtraFilters({
  queryParams,
  setQueryParams,
}: ExtraFiltersProps<ListForecastPayableQuery>) {
  const intl = useIntl();

  return (
    <Row gutter={[16, 16]}>
      <Col xs={24} sm={24} lg={4} md={12}>
        <CompaniesInfiniteSelectField
          value={queryParams?.companyId}
          placeholder={intl.formatMessage({
            id: 'predictions.list.header.companies',
          })}
          allowClear
          onChange={(values) =>
            setQueryParams((prev) => ({ ...prev, companyId: values }))
          }
          queryFilter={{ active: true }}
        />
      </Col>

      <Col xs={24} sm={24} lg={8} md={12}>
        <Input
          value={queryParams?.creditor}
          onChange={({ target: { value } }) =>
            setQueryParams((prev) => ({ ...prev, creditor: value }))
          }
          placeholder={intl.formatMessage({
            id: 'predictions.list.header.creditor',
          })}
        />
      </Col>

      <Col xs={24} sm={24} lg={4} md={12}>
        <Input
          value={queryParams?.description}
          onChange={({ target: { value } }) =>
            setQueryParams((prev) => ({ ...prev, description: value }))
          }
          placeholder={intl.formatMessage({
            id: 'predictions.list.header.description',
          })}
        />
      </Col>
    </Row>
  );
}

export default ForecastPayableExtraFilters;
